import { render, staticRenderFns } from "./AddPlant.vue?vue&type=template&id=380568aa&scoped=true&"
import script from "./AddPlant.vue?vue&type=script&lang=js&"
export * from "./AddPlant.vue?vue&type=script&lang=js&"
import style0 from "./AddPlant.vue?vue&type=style&index=0&id=380568aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380568aa",
  null
  
)

export default component.exports